'use strict'

import React from 'react';
import request from 'superagent';

import AreaForm from '../components/AreaForm.jsx';
import FormattedContent from '../components/FormattedContent.jsx';
import {Risk} from '../Risk.jsx';
import {Change} from '../Change.jsx';
import {Report} from '../Report.jsx';

import ReportMenu from './ReportMenu.jsx';
import uuid from 'uuid';

import formDefinition from './formDefinition.js';
import sendCommand from '../../app/utils/sendCommand.js';

import Translations from '../../app/utils/translations.js';

let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ])
  .loadVariants([
    require('./labels/english_endStage.js'),
    require('./labels/norwegian_endStage.js'),
    require('./labels/english_endProject.js'),
    require('./labels/norwegian_endProject.js'),
    require('./labels/english_release.js'),
    require('./labels/norwegian_release.js'),
    require('./labels/english_product.js'),
    require('./labels/norwegian_product.js')
  ]);

class ReportActions extends React.Component {
  constructor(props) {
    super(props);
    this.state={savedDraft: false};
  }

  componentWillReceiveProps(props) {
    this.setState({savedDraft: false});
  }

  saveDraft(event) {
    if (this.state.savedDraft) {
      event.preventDefault();
    } else {
      this.setState({savedDraft:true});
    }
  }
  render() {
    let labels=translations.getTranslation(this.props).report;
    return (
      <div style={{height:40}} >
        <input onClick={this.props.onCancel} name="cancel" className="cancel" value={labels.cancel} type="button"/>
        {this.state.savedDraft ? <input name="savedDraft" type="hidden" value="true"/> : null}
        <input onClick={this.saveDraft.bind(this)} className="save" value={(this.state.savedDraft ? labels.inProgress : labels.saveDraft)} type="submit"/>
      </div>
    );
  }
}

class ReportPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state={published:false};
  }

  componentWillReceiveProps(props) {
    this.setState({published:false});
  }

  publish(event) {
    if (this.state.published) {
      event.preventDefault();
    } else {
      this.setState({published:true});
    }
    if (this.props.publishReport!==undefined) {
      this.props.publishReport(event);
    }
  }

  render() {
    let labels=translations.getTranslation(this.props).report;
    var highlightReport={};
    if (this.props.values!==undefined) {
      let values=this.props.values;
      var from=undefined;
      var to=undefined;
      if (values.period!==undefined) {
        if (values.period.from!==undefined) {
          from=values.period.from;
        }
        if (values.period.to!==undefined) {
          to=values.period.to;
        }
        if (typeof values.period==="string") {
          var parts=values.period.split(" to ");
          if (parts.length>0) {
            from=parts[0];
          }
          if (parts.length>1) {
            to=parts[1];
          }
        }
      }
      highlightReport={
        overallStatus: {
          content: values.summary,
          status: values.summary_status
        },
        endProject: this.props.endProject,
        stage: this.props.endStage && this.props.project.currentStage!==undefined
          ? { id: this.props.project.currentStage.id } : null,
        performedAchivements: values.performedAchivements,
        plannedAchivements: values.plannedAchivements,
        benefits: {
          content: values.benefits,
          status: values.benefits_status
        },
        time: {
          content: values.time,
          status: values.time_status
        },
        cost: {
          content: values.cost,
          status: values.cost_status
        },
        quality: {
          content: values.quality,
          status: values.quality_status
        },
        scope: {
          content: values.scope,
          status: values.scope_status
        },
        risk: {
          content: values.risk,
          status: values.risk_status
        },
        teamPerformance: values.teamPerformance,
        lessonsDescription: values.lessonsDescription,
        updatedBy: this.props.user.id,
        from: from,
        date: to,
        statusDate: to
      };
    } else {
      highlightReport=this.props.report;
    }

        return (
      <div className="report" style={{fontSize:"12pt"}}>
        <div style={{paddingTop:10, paddingBottom:35}}>
          {this.state.published ? <input type="hidden" name="published" value="true"/> : null}
          <input onClick={this.publish.bind(this)} type="submit" className="save" value={!this.state.published ? labels.publishReport : labels.publishInProgress}/>
        </div>
        <Report
          {...this.props}
          selected={this.props.values!==undefined ? "preview" : "draft"}
          project={this.props.values!==undefined
              ? Object.assign({},this.props.project,{
                  issues:this.props.issues,
                  risks:this.props.risks,
                  draftHighlight:highlightReport
                })
              : this.props.project
            }
          tenant={this.props.tenant}
          user={this.props.user}
        />
        <div style={{paddingTop:35, paddingBottom:55}}>
          {this.state.published ? <input type="hidden" name="published" value="true"/> : null}
          <input onClick={this.publish.bind(this)} type="submit" className="save" value={!this.state.published ? labels.publishReport : labels.publishInProgress}/>
        </div>
      </div>
    );
  }
}

class StageDetails extends React.Component {
  render() {
    return (
      <div>
        <b>{this.props.name}</b>
        <span>, {this.props.time.start} - {this.props.time.end} ({this.props.time.tolerance})</span>
        <div>
          <i><FormattedContent value={this.props.comments}/></i>
        </div>
      </div>

    );
  }
}

export default class TabReport extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      showPreview: false,
      report: this.asFormFields(this.props.report,this.props.lastReport),
      lastSavedReport: this.props.report,
      issues: this.props.issues!==undefined ? this.props.issues : this.props.project!==undefined && this.props.project.issues!==undefined ? this.props.project.issues : [],
      risks: this.props.risks!==undefined ? this.props.risks : this.props.project!==undefined && this.props.project.risks!==undefined ? this.props.project.risks : [],
    };
    this.warningOnLeave=this.changeWarningOnLeave.bind(this)
  }

  asFormFields(report,lastReport) {
    return Object.assign({},{},{
      _currentProgress: report._currentProgress,
      period: { from: report.from, to: report.date },
      summary:report.overallStatus.content,
      summary_status: report.overallStatus.status,
      performedAchivements: report.performedAchivements,
      plannedAchivements: report.plannedAchivements,
      benefits: report.benefits.content,
      benefits_status: report.benefits.status,
      time: report.time.content,
      time_status: report.time.status,
      cost: report.cost.content,
      cost_status: report.cost.status,
      quality: report.quality.content,
      quality_status: report.quality.status,
      scope: report.scope.content,
      scope_status: report.scope.status,
      risk: report.risk.content,
      risk_status: report.risk.status,
      teamPerformance: report.teamPerformance,
      lessonsDescription: report.lessonsDescription,
      previousValues: lastReport!==undefined ? {
        summary: lastReport.summary!==undefined ? lastReport.summary.content : undefined,
        summary_status: lastReport.summary!==undefined ? lastReport.summary.status : undefined,
        performedAchivements: lastReport.performedAchivements,
        plannedAchivements: lastReport.plannedAchivements,
        benefits: lastReport.benefits!==undefined ? lastReport.benefits.content : undefined,
        benefits_status: lastReport.benefits!==undefined ? lastReport.benefits.status : undefined,
        time: lastReport.time!==undefined ? lastReport.time.content : undefined,
        time_status: lastReport.time!==undefined ? lastReport.time.status : undefined,
        cost: lastReport.cost!==undefined ? lastReport.cost.content : undefined,
        cost_status: lastReport.cost!==undefined ? lastReport.cost.status : undefined,
        quality: lastReport.quality!==undefined ? lastReport.quality.content : undefined,
        quality_status: lastReport.quality!==undefined ? lastReport.quality.status : undefined,
        scope: lastReport.scope!==undefined ? lastReport.scope.content : undefined,
        scope_status: lastReport.scope!==undefined ? lastReport.scope.status : undefined,
        risk: lastReport.risk!==undefined ? lastReport.risk.content : undefined,
        risk_status: lastReport.risk!==undefined ? lastReport.risk.status : undefined,
      } : undefined,
      _progress:"Preview"
    });
  }

  summary(tab, values, originalValues) {
    var content=undefined;
    switch (tab) {
      case "Plan":
        if (this.props.endProject) {
          content=null;
        } else {
          content=this.props.project.currentStage!==undefined ? (
            <StageDetails {...this.props.project.currentStage}/>
          ) : undefined;
        }
        break;
      default:
        if (this.props.endProject) {
          content=null;
        } else if (this.props.endStage && this.props.project.currentStage!==undefined) {
          content=<StageDetails {...this.props.project.currentStage}/>;
        } else {
          content=undefined;
        }
    }
    return content!==undefined ? (
      <div style={{fontFamily:"Arial", fontSize:"10pt", padding:10, textAlign:"left"}}>
        {content}
      </div>

    ) : null;
  }

  updateIssues(issues) {
    this.setState({issues:issues, modified:true});
  }

  updateRisks(risks) {
    this.setState({risks:risks, modified:true});
  }

  details(tab, values, originalValues) {
    var content=undefined;
    let labels=translations.getTranslation(this.props).report;
    switch (tab) {
      case "Preview":
        content=<ReportPreview {...this.props} values={values} issues={this.state.issues} risks={this.state.risks} publishReport={this.publishReport.bind(this)}/>;
        break;

      case "Overview":
        content=this.props.endProject
          ? undefined
          : (
            <div>
            {this.state.risks.filter(item=>item.status!=="Closed").length>0 ?
              (
              <div style={{paddingBottom:50, textAlign:"left"}}>
              <br/>{labels.listLimitedTo}<b> {labels.top5Risks}</b>:
                <Risk
                  {...this.props}
                  project={this.props.project}
                  mode="followUp"
                  size={5}
                  risks={this.state.risks.filter(item=>item.status!=="Closed")}
                  onUpdate={this.updateRisks.bind(this)}
                />
              </div>
              )
              : null}
            {this.state.issues.filter(item=>item.status!=="Closed").length>0 ?
              (
              <div style={{textAlign:"left"}}>
              <br/>{labels.listLimitedTo}<b> {labels.top5Issues}</b>:
                <Change
                  {...this.props}
                  hideReports={true}
                  project={this.props.project}
                  mode="followUp"
                  size={5}
                  issues={this.state.issues.filter(item=>item.status!=="Closed")}
                  hideMenu={true}
                  onUpdate={this.updateIssues.bind(this)}
                />
              </div>
              )
              : null}
          </div>
        )
        break;

      default:
        content=undefined;
    }
    return content!==undefined ? (
      <div style={{borderTop: "solid 5px #8faadc", marginTop:15, fontFamily:"Arial", fontSize:"10pt"}}>
        {content}
      </div>
    ) : null;
  }

  showReportPreview(event) {
    event.preventDefault();
    this.setState({showPreview: !this.state.showPreview});
  }

/*
  sendCommand(command,success) {
    request
      .post("/")
      .send(command)
      .end(function(error, response) {
        if (error===null && response.status===200) {
          var message=JSON.parse(response.text);
          if (message.status==="OK") {
            console.log("Success for command '"+command.type+"'");
            success(message.report);
          } else {
            console.log("Error: "+message.message);
            window.alert("Not able to save or publish highlight report");
          }
        } else {
          console.log("Error: "+error+", got "+response.status+" with message "+response.text);
          window.alert("Not able to save or publish highlight report");
        }
      });
  }
*/

  getHighlightReport(form) {
    var fromDate=undefined;
    var toDate=undefined;
    if (typeof form.period==="string") {
      var parts=form.period.split(" to ");
      fromDate=parts.length>0 ? parts[0] : undefined;
      toDate=parts.length>1 ? parts[1] : undefined;
    } else {
      if (form.period!==undefined) {
        fromDate=form.period.from;
        toDate=form.period.to;
      } else {
        fromDate=undefined;
        toDate=new Date();
      }
    }
    const currentManager=this.props.project!==undefined && this.props.project.stakeholders!==undefined
      ? this.props.project.stakeholders.find(stakeholder=>stakeholder.role==="Project Manager" || stakeholder.role==="Product Manager")
      : undefined;
    let report={
      id: this.props.report.id!==undefined ? this.props.report.id : uuid.v4(),
      stage: this.props.endStage && this.props.project.currentStage!==undefined ?
        { id: this.props.project.currentStage.id } : undefined,
      from: fromDate,
      date: toDate,
      manager: currentManager,
      summary: {
        status: form.summary_status,
        content: form.summary
      },
      performedAchivements: form.performedAchivements,
      plannedAchivements: form.plannedAchivements,
      benefits: {
        status: form.benefits_status,
        content: form.benefits
      },
      time: {
        status: form.time_status,
        content: form.time
      },
      cost: {
        status: form.cost_status,
        content: form.cost
      },
      quality: {
        status: form.quality_status,
        content: form.quality
      },
      scope: {
        status: form.scope_status,
        content: form.scope,
      },
      risk: {
        status: form.risk_status,
        content: form.risk
      },
    };
    if (this.props.endProject || this.props.endStage) {
      report.teamPerformance=form.teamPerformance;
      report.lessonsDescription=form.lessonsDescription;
    }
    return report;
  }

  publishReport() {
    var command={
      type: this.props.endProject
        ? "publishEndProjectReport"
        : this.props.endStage
          ? "publishEndStageReport"
          : "publishHighlightReport",
      report:this.getHighlightReport(this.state.report)
    };
    if (this.props.project.isProduct) {
      command=Object.assign({},command,{
        product: {id: this.props.project.id}
      });
    } else if (this.props.project.isProgramme) {
      command=Object.assign({},command,{
        programme: {id: this.props.project.id}
      });
    } else if (this.props.project.isRelease) {
      command=Object.assign({},command,{
        release: {id: this.props.project.id}
      });
    }else {
      command=Object.assign({},command,{
        project: {id: this.props.project.id}
      });
    }
    sendCommand(command)
      .then(response => {
        this.setState({published: true}, () => window.location=(this.props.project.isProduct ? "/products/" : this.props.project.isProgramme ? "/programmes/" : this.props.project.isRelease ? "/releases/" : "/projects/")+this.props.project.id+"/reports/?id="+command.report.id+(this.props.endStage ?"&showEndStage=true" : ""));
        window.removeEventListener("beforeunload",this.changeWarningOnLeave.bind(this));
      })
      .catch(error=>{
        console.log("Got error", error);
        this.setState({modified:false});
        alert("Not able to publish report, please try again");
      })
  }

  update(reportForm) {
    if (reportForm.savedDraft==="true") {
      var command={
        type: this.props.endProject
          ? "saveEndProjectReportDraft"
          : this.props.endStage
            ? "saveEndStageReportDraft"
            : "saveHighlightReportDraft",
        report:this.getHighlightReport(reportForm)
      };
      if (this.props.project.isProduct) {
        command=Object.assign({},command,{
          product: {id: this.props.project.id}
        });
      } else if (this.props.project.isProgramme) {
        command=Object.assign({},command,{
          programme: {id: this.props.project.id}
        });
      } else if (this.props.project.isRelease) {
        command=Object.assign({},command,{
          release: {id: this.props.project.id}
        });
      }
      else {
        command=Object.assign({},command,{
          project: {id: this.props.project.id}
        });
      }
      sendCommand(command)
        .then(response => this.setState({
          lastSavedReport: response.report,
          report:this.asFormFields(Object.assign({},response.report,{_currentProgress: reportForm._progress}), this.props.lastReport),
          modified:undefined
        }))
        .catch(error=>{
          console.log("Got error",error);
          this.setState({modified:false});
          alert("Not able to save report, please try again");
        })
    }
  }

  hasChanged(lastSavedReport) {
    var report=this.asFormFields(lastSavedReport);
    return formDefinition.map(area=> area.fields!==undefined && area.fields.map(field=>
        JSON.stringify(report[field.name])!==JSON.stringify(this.state.report[field.name])
        || (field.includeStatus && JSON.stringify(report[field.name+"_status"])!==JSON.stringify(this.state.report[field.name+"_status"]))
      ).reduce((value,result)=>result || value)).reduce((value,result)=>result || value);
  }

  changeWarningOnLeave(e) {
    if (this.hasChanged(this.state.lastSavedReport) && !this.state.published) {
      e.returnValue="Do you want to keep changes?";
      return "Do you want to keep changes?";
    }
  }
  componentDidMount() {
    window.addEventListener("beforeunload", this.warningOnLeave);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload",this.warningOnLeave);
  }

  handleFieldChange(fieldName) {
    return (event)=>{
      this.setState({
        report:Object.assign({},this.state.report,{[event.target.name]:event.target.value}),
        modified:true
      });
    };
  }


  render() {
    var actions=<ReportActions {...this.props} onCancel={this.props.onCancel}/>;
    let displayType=this.props.endStage && this.props.project.currentStage!==undefined
      ? "endStage"
      : this.props.endProject==true
        ? "endProject"
        : "normal";
    let areas=translations.createTranslatedForm(formDefinition,this.props.language,this.props.variant);
    return this.state.showPreview ? (
      <div style={{display:"flex", justifyContent:"center"}}>
        <div style={{flexBasis: "100%", maxWidth:1016, minWidth:250}}>
          <ReportPreview
            {...this.props}
            cancel={this.showReportPreview.bind(this)}
            publish={this.publishReport.bind(this)}
          />
        </div>
      </div>
      ) : (
        <div style={{textAlign:"left"}}>
          <div style={{display:"flex", justifyContent:"center"}}>
            <div style={{flexBasis: "100%", maxWidth:1016, minWidth:250}}>
              <div>
                <AreaForm
                  {...this.props}
                  areas={areas}
                  display="tab"
                  summary={this.summary.bind(this)}
                  details={this.details.bind(this)}
                  item={this.state.report}
                  actions={actions}
                  selected={0}
                  onUpdate={this.update.bind(this)}
                  modified={this.state.modified}
                  handleFieldChange={this.handleFieldChange.bind(this)}
                  displayType={displayType}
                />
              </div>
             </div>
           </div>
         </div>
       );
  }
}



// WEBPACK FOOTER //
// ./views/progress/TabReport.jsx